
import Hero from './components/Hero';
import About from './components/About';
import CitizenRegistration from './components/CitizenRegistration';
import MicroKnowledge from './components/MicroKnowledge';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Hero />
      <About />
      <CitizenRegistration />
      <MicroKnowledge />
      <Contact />
      <Footer />
    </div>
  );
}
